<script setup lang="ts">
import { cn } from '@/lib/utils'
import type { HTMLAttributes } from 'vue'
import { paymentHeaderVariants, PaymentHeaderVariants } from '.'

interface Props {
    variant?: PaymentHeaderVariants['variant']
    class?: HTMLAttributes['class']
}

const props = defineProps<Props>()
</script>

<template>
    <header :class="cn('flex flex-col justify-between gap-8 lg:flex-row', paymentHeaderVariants({ variant }), props.class)">
        <slot />
    </header>
</template>
